import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "order-orders"
};
const _hoisted_2 = {
  class: "main-wrap"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 0,
  class: "order-vehicle-Type taxi"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "vehicle-type-name"
}, "出租车", -1);
const _hoisted_6 = {
  key: 1,
  class: "order-vehicle-Type new-taxi"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "vehicle-type-name"
}, "新出租", -1);
const _hoisted_8 = {
  class: "order-info"
};
const _hoisted_9 = {
  class: "order-info-item order-time"
};
const _hoisted_10 = {
  class: "icon"
};
const _hoisted_11 = {
  class: "text"
};
const _hoisted_12 = {
  class: "order-info-item"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
})], -1);
const _hoisted_14 = {
  class: "text"
};
const _hoisted_15 = {
  class: "order-info-item"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
})], -1);
const _hoisted_17 = {
  class: "text"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 0,
  class: "order-vehicle-Type"
};
const _hoisted_20 = {
  key: 1,
  class: "order-vehicle-Type"
};
const _hoisted_21 = {
  class: "order-info"
};
const _hoisted_22 = {
  class: "order-info-item order-time"
};
const _hoisted_23 = {
  class: "icon"
};
const _hoisted_24 = {
  class: "order-info-item"
};
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
})], -1);
const _hoisted_26 = {
  class: "order-info-item"
};
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
})], -1);
const _hoisted_28 = {
  key: 0,
  class: "order-vehicle-Type taxi"
};
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "vehicle-type-name"
}, "出租车", -1);
const _hoisted_30 = {
  key: 1,
  class: "order-vehicle-Type new-taxi"
};
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "vehicle-type-name"
}, "新出租", -1);
const _hoisted_32 = {
  class: "voice-order-info"
};
const _hoisted_33 = {
  class: "order-info-item order-attr"
};
const _hoisted_34 = {
  class: "time"
};
const _hoisted_35 = {
  class: "icon"
};
const _hoisted_36 = {
  key: 0,
  class: "address"
};
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
})], -1);
const _hoisted_38 = {
  class: "text"
};
const _hoisted_39 = {
  key: 1,
  class: "address"
};
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
})], -1);
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "通过微信小程序叫车", -1);
const _hoisted_42 = [_hoisted_40, _hoisted_41];
const _hoisted_43 = {
  class: "order-info-item order-voice-play"
};
const _hoisted_44 = ["onClick"];
const _hoisted_45 = ["id", "onPlay", "onEnded"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_nav_bar, {
    border: false,
    title: $setup.title
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_tabs, {
    color: "#ffb54d",
    active: $setup.tabActive,
    "onUpdate:active": _cache[3] || (_cache[3] = $event => $setup.tabActive = $event),
    swipeable: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: "已完成"
    }, {
      default: _withCtx(() => [!$setup.orders || $setup.orders.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        description: "未查询到已完成的行程数据"
      })) : _createCommentVNode("", true), $setup.orders && $setup.orders.length > 0 ? (_openBlock(), _createBlock(_component_van_list, {
        key: 1,
        loading: $setup.ordersLoading,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => $setup.ordersLoading = $event),
        finished: $setup.ordersFinished,
        "finished-text": "已加载全部已完成的行程",
        onLoad: $options.ordersOnLoad
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orders, (order, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "card order-card",
            key: index,
            onClick: $event => $options.goFinish(index)
          }, [_createVNode(_component_van_cell, {
            value: "已完成",
            "is-link": ""
          }, {
            title: _withCtx(() => [order.service_car_type === 'ORDER_CAR_TYPE_NORMAL_TAXI' || order.service_car_type === undefined ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_icon, {
              name: require('@/assets/icon/taxi-type.png')
            }, null, 8, ["name"]), _hoisted_5])) : _createCommentVNode("", true), order.service_car_type === 'ORDER_CAR_TYPE_ONLINE_TAXI' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_van_icon, {
              name: require('@/assets/icon/new-taxi-type.png')
            }, null, 8, ["name"]), _hoisted_7])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_van_icon, {
            name: "clock"
          })]), _createElementVNode("div", _hoisted_11, _toDisplayString(order.car_usage_time), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(order.departure_address), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(order.destination_address), 1)])])], 8, _hoisted_3);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_van_tab, {
      title: "待付款"
    }, {
      default: _withCtx(() => [!$setup.waitPayOrders || $setup.waitPayOrders.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        description: "未查询到待付款的行程数据"
      })) : _createCommentVNode("", true), $setup.waitPayOrders && $setup.waitPayOrders.length > 0 ? (_openBlock(), _createBlock(_component_van_list, {
        key: 1,
        loading: $setup.waitPayOrdersLoading,
        "onUpdate:loading": _cache[1] || (_cache[1] = $event => $setup.waitPayOrdersLoading = $event),
        finished: $setup.waitPayOrdersFinished,
        "finished-text": "已加载全部待付款的行程",
        onLoad: $options.waitPayOrdersOnLoad
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.waitPayOrders, (order, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "card order-card",
            key: index,
            onClick: $event => $options.goCheckout(index)
          }, [_createVNode(_component_van_cell, {
            value: "待付款",
            "is-link": ""
          }, {
            title: _withCtx(() => [order.service_car_type === 'ORDER_CAR_TYPE_NORMAL_TAXI' || order.service_car_type === undefined ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_van_icon, {
              name: require('@/assets/icon/vehicle/taxi.png')
            }, null, 8, ["name"]), _createTextVNode(" 出租车 ")])) : _createCommentVNode("", true), order.service_car_type === 'ORDER_CAR_TYPE_ONLINE_TAXI' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_van_icon, {
              name: require('@/assets/icon/vehicle/taxi-new.png')
            }, null, 8, ["name"]), _createTextVNode(" 新出租 ")])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_van_icon, {
            name: "clock"
          })]), _createElementVNode("div", null, _toDisplayString(order.car_usage_time), 1)]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", null, _toDisplayString(order.departure_address), 1)]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", null, _toDisplayString(order.destination_address), 1)])])], 8, _hoisted_18);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])) : _createCommentVNode("", true)]),
      _: 1
    }), false ? (_openBlock(), _createBlock(_component_van_tab, {
      key: 0,
      title: "待评价"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_empty, {
        description: "未查询到待评价的行程数据"
      })]),
      _: 1
    })) : _createCommentVNode("", true), false ? (_openBlock(), _createBlock(_component_van_tab, {
      key: 1,
      title: "语音单"
    }, {
      default: _withCtx(() => [!$setup.voiceOrders || $setup.voiceOrders.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        description: "未查询到语音单的行程数据"
      })) : _createCommentVNode("", true), $setup.voiceOrders && $setup.voiceOrders.length > 0 ? (_openBlock(), _createBlock(_component_van_list, {
        key: 1,
        loading: $setup.voiceOrdersLoading,
        "onUpdate:loading": _cache[2] || (_cache[2] = $event => $setup.voiceOrdersLoading = $event),
        finished: $setup.voiceOrdersFinished,
        "finished-text": "已加载全部语音单行程",
        onLoad: $options.voiceOrdersOnLoad
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.voiceOrders, (order, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "card order-card",
            key: index
          }, [_createVNode(_component_van_cell, {
            value: "已完成",
            "is-link": ""
          }, {
            title: _withCtx(() => [order.orderCarType === 1 || order.orderCarType === undefined ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_van_icon, {
              name: require('@/assets/icon/taxi-type.png')
            }, null, 8, ["name"]), _hoisted_29])) : _createCommentVNode("", true), order.orderCarType === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_component_van_icon, {
              name: require('@/assets/icon/new-taxi-type.png')
            }, null, 8, ["name"]), _hoisted_31])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_van_icon, {
            name: "clock"
          })]), _createTextVNode(" " + _toDisplayString(order.orderCreateTime), 1)]), order.orderTargetAddress && order.orderTargetAddress.length > 0 && order.orderTargetAddress !== '未提供(--)' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_hoisted_37, _createElementVNode("div", _hoisted_38, _toDisplayString(order.orderTargetAddress), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_42))]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", {
            class: "icon",
            onClick: $event => $options.playVoice(index)
          }, [!order.isPlaying ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 0,
            name: "play-circle-o"
          })) : _createCommentVNode("", true), order.isPlaying ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 1,
            name: "stop-circle-o"
          })) : _createCommentVNode("", true)], 8, _hoisted_44), _createElementVNode("audio", {
            id: 'audio-' + order.order_id,
            style: {
              "display": "none"
            },
            autoplay: "",
            onPlay: $event => order.isPlaying = true,
            onEnded: $event => order.isPlaying = false
          }, null, 40, _hoisted_45)])])]);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["active"])])]);
}